import { AfterViewInit, Component, ElementRef, HostListener, inject, Input, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { FormContainerKind, ValidationLimits, Validators } from '@sb/library/base';
import { debounceTime } from 'rxjs';
import { FormFieldInputBaseComponent } from '../form-field-input-base.component';

@Component({
    selector: 'lib-input-text',
    templateUrl: './form-field-text.component.html',
    styleUrls: ['./form-field-text.component.scss']
})
export class FormFieldTextComponent extends FormFieldInputBaseComponent<string> implements OnInit, AfterViewInit {

    @ViewChildren('input') input!: QueryList<ElementRef<HTMLInputElement>>;


    @Input() kindOverride: FormContainerKind = FormContainerKind.Text;

    private _inputFilter: RegExp | undefined = undefined;
    @Input()
    set inputFilter(value: string) {
        this._inputFilter = new RegExp(`(${value})|.`, 'g');
    }
    

    protected readonly Renderer: Renderer2 = inject(Renderer2);

    override readonly hasPrefixIconButton: boolean = !!this.prefixIcon;


    private _previousValue: string = '';

    constructor() {
        super();
        this.viewControl.valueChanges.subscribe(value => {
            if (this.formControl !== undefined && this.formControl.value !== value?.trim()) {
                this.SetFormControlValue(value?.trim());
            }
        })
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.formControl.AddDefaultValidators(Validators.maxLength(ValidationLimits.Text.MaxLength));
    }

    ngAfterViewInit() {
        if (this.debounceTime !== null && this.debounceTime !== undefined) {
            this.viewControl.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe(value => {
                this.realTimeValueChanged.emit(value);
            })
        }
    }

    @HostListener('input', ['$event'])
    ApplyFilter() {
        const rawValue = this.viewControl.value;

        if (this._inputFilter && rawValue) {
            this.viewControl.setValue(rawValue.replace(this._inputFilter, '$1'));
        }
    }
}
